import { render } from "./ByLiftRoadmap.vue?vue&type=template&id=2c9c1680&scoped=true"
import script from "./ByLiftRoadmap.vue?vue&type=script&lang=js"
export * from "./ByLiftRoadmap.vue?vue&type=script&lang=js"

import "./ByLiftRoadmap.vue?vue&type=style&index=0&id=2c9c1680&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9c1680"]])

export default __exports__